export const URL = "https://www.trottrapi.com";
export const LCURL = "http://localhost:3000";
export const SECRET = 'M!zzT33tz$33';
export const GOOG_API_KEY = 'AIzaSyBmHU3g6fsR9hS0rR95GmymoLDDt4vGoB4';
export const AUTH0_DOMAIN = 'login.trottr.com';
export const AUTH0_CLIENTID = 'h1QfIlRUrZe2bK25daNMTnNV5oMFqqdU';
export const CALLBACK_URL = "https://trottr.com/";
export const IMG_URL = 'https://uploads.trottr.com';